/* eslint-disable no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useRef, useState } from "react";
import Header from "../../Layout/Header";
import Footer from "../../Layout/Footer";
import DoctorCards from "../../Component/DoctorCards";
import {
  GoogleMap,
  useJsApiLoader,
  MarkerF,
  Autocomplete,
} from "@react-google-maps/api";
import axios from "axios";
import { Link, useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import BaseURL from "../../BaseURL/BaseURL";
import { useDispatch } from "react-redux";
import { doctorapi } from "../../Redux/Slice/Slice";

const containerStyle = {
  width: "100%",
  height: "500px",
};

const center = {
  lat: 24.8607343,
  lng: 67.0011364,
};

const Home = () => {
  const [, setLoader] = useState(false);
  const [api, setApi] = useState([]);
  const [, setSearchApi] = useState([]);
  const [Data, setData] = useState([]);
  const [Type, setType] = useState("");
  const [Zip, setZip] = useState("");

  const dispatch = useDispatch();

  const alldoctor = () => {
    setLoader(true);
    try {
      var config = {
        method: "Get",
        url: `${BaseURL.baseurl}/api/doctors`,
      };

      axios(config)
        .then(function (response) {
          console.log(response, "api");
          setApi(response.data.data);
          setData(response.data.data?.slice(0, 6));
          dispatch(doctorapi(response.data.data));
        })
        .catch((errors) => {
          setLoader(false);
          Swal.fire({
            title: "Something Went Wrong",
            text: errors.errors ? errors.errors[0] : "check your Details",
            icon: "error",
            dangerMode: true,
          });
        });
    } catch (errors) {
      setLoader(false);
      console.log(errors, "error");
      Swal.fire({
        title: "Something Went Wrong",
        text: errors.errors ? errors.errors[0] : "check your Details",
        icon: "error",
        dangerMode: true,
      });
    }
  };

  useEffect(() => {
    alldoctor();
  }, []);

  const [Position, setPosition] = useState({
    lat: 0,
    lng: 0,
  });
  const [PlaceName, setPlaceName] = useState("");
  //google map work

  const { isLoaded } = useJsApiLoader({
    // id: "google-map-script",
    googleMapsApiKey: "AIzaSyDF1PVJNBK1GGAQmfCpc-yepBkGUdkfgVQ",
    libraries: ["places"],
  });
  const autoCompleteRef = useRef();
  const inputRef = useRef();

  useEffect(() => {
    console.log("useeffect", +1);
    autoCompleteRef.current = new window.google.maps.places.Autocomplete(
      inputRef.current
    );
    autoCompleteRef.current.addListener("place_changed", async function () {
      const Place = await autoCompleteRef.current.getPlace();
      // console.log(place.geometry.location.lat(),"place");
      // console.log(place.geometry.location.lng(),"place");
      setPosition({
        lat: Place.geometry.location.lat(),
        lng: Place.geometry.location.lng(),
      });
      // setPlaceName(place.formatted_address);
      setPlaceName(Place.name);
      console.log(Place, "place");
    });
  }, [Position]);
  console.log(Position.lat, "place");
  console.log(Position.lng, "place");
  console.log(PlaceName, "place");
  console.log(Position, "place");

  //google map work

  const navigate = useNavigate();

  const search = () => {
    setLoader(true);
    try {
      var config = {
        method: "Get",
        url: `${BaseURL.baseurl}/api/doctors?type=${Type}&zipcode=${Zip}&street_address=${PlaceName}`,
      };

      axios(config)
        .then(function (response) {
          console.log(response, "api");
          setSearchApi(response.data.data);
          navigate("/practitioner", { state: response.data.data });
        })
        .catch((errors) => {
          setLoader(false);
          Swal.fire({
            title: "Something Went Wrong",
            text: errors.errors ? errors.errors[0] : "check your Details",
            icon: "error",
            dangerMode: true,
          });
        });
    } catch (errors) {
      setLoader(false);
      console.log(errors, "error");
      Swal.fire({
        title: "Something Went Wrong",
        text: errors.errors ? errors.errors[0] : "check your Details",
        icon: "error",
        dangerMode: true,
      });
    }
  };

  const markerOptions = [
    {
      color: "yellow",
    },
    {
      color: "green",
    },
    {
      color: "blue",
    },
  ];
  return (
    <>
      <Header />
      <div class="hero_map">
        <div className="" style={{}}>
          <GoogleMap
            mapContainerStyle={containerStyle}
            center={
              Position.lat !== 0 && Position.lng !== 0 ? Position : center
            }
            zoom={1.5}
            options={{
              zoomControl: false,
              streetViewControl: false,
              mapTypeControl: false,
              fullscreenControl: false,
            }}
          >
            {api.map((e, index) => {
              return (
                <MarkerF
                  key={index}
                  position={{
                    lat: Number(e.latitude),
                    lng: Number(e.longitude),
                  }}
                  icon={
                    e.type === "dentist"
                      ? {
                          url: `https://maps.google.com/mapfiles/ms/icons/${markerOptions[1].color}-dot.png`,
                        }
                        : e.type === 'doctor'? {
                        url: `https://maps.google.com/mapfiles/ms/icons/${markerOptions[0].color}-dot.png`,
                      }
                      : e.type === 'hypnotherapist'? {
                        url: `https://maps.google.com/mapfiles/ms/icons/${markerOptions[2].color}-dot.png`,
                      }:null}
                      
                />
              );
            })}
          </GoogleMap>
        </div>
        <form class="search_wp mt-2">
          <div id="custom-search-input">
            <div class="d-flex justify-content-between row">
              <div className="col-12 col-md-3 px-0 mb-1">
                <Autocomplete>
                  <input
                    type="text"
                    ref={inputRef}
                    class="p-3 border-0 location w-100"
                    placeholder="Ex. Name, Specialization ...."
                  />
                </Autocomplete>
              </div>
              <div className="col-12 col-md-3 px-0 mb-1">
                <select
                  class="form-select h-100"
                  aria-label="Default select example"
                  onChange={(e) => {
                    setType(e.target.value);
                  }}
                  style={{ opacity: 1, borderRadius: 0, border: 0 }}
                >
                  <option selected>Select Doctor Type</option>
                  <option value="Doctor">Doctor</option>
                  <option value="Dentist">Dentist</option>
                  <option value="hypnotherapist">hypnotherapist</option>
                </select>
              </div>
              <div className="col-12 col-md-3 px-0 mb-1">
                <input
                  type="tel"
                  class="w-100 p-3 border-0 location"
                  placeholder="Enter Zip Code"
                  onChange={(e) => {
                    setZip(e.target.value);
                  }}
                />
              </div>

              <button
                type="button"
                class="btn-theme rounded-0 col-12 col-md-3"
                onClick={search}
              >
                Search
              </button>
            </div>
          </div>
        </form>
      </div>
      <div class="bg_color_1 mt-5">
        <div class="container margin_120_95">
          <div class="main_title">
            <h2>What is GAFHC?</h2>
            <p>
              The Global Alliance for Hypnosis Clinicians (GAFHC) is the world’s
              most comprehensive database, training network, and certification
              program of medical doctors, dentists, and hypnosis practitioners
              specializing in medical hypnosis. The field of hypnosis is largely
              misunderstood and therefore underutilized in clinical settings.
              While hypnoanalgesia refers to the implementation of hypnosis in
              place of chemical anesthesia for invasive procedures, medical
              hypnosis can be utilized in a wide array of clinical situations
              such as helping patients overcome phobias, accelerating the
              recovery time from surgery, and providing significant pain relief.
              GAFHC aims to overcome the long-held stigma regarding hypnosis and
              expand the application of this technique in medical settings all
              across the globe.
            </p>
          </div>

          <div class="row">
            {Data?.map((e) => (
              <DoctorCards
                id={e?.id}
                fname={e?.fname}
                lname={e?.lname}
                address={e?.street_address}
                city={e?.city}
                country={e?.country}
                type={e?.type}
                image={e?.image}
                rating={e?.averageRating}
              />
            ))}
          </div>
          {/* <!-- /row --> */}
          <p class="text-center add_top_30 mb-5">
            <Link to="/practitioner" class="btn btn-primary">
              View all practitioners
            </Link>
          </p>
        </div>
        {/* <!-- /container --> */}
        {/* <div className="container">
          <div className="row">
            <div className="col-md-12 text-center">
              <h1>Intern Opportunities</h1>
              <p className="fs-5 py-3">
                If you have a passion for clinical hypnosis and the potential to
                help the public, please <Link to={"/contact"}>contact us</Link> to get involved.
              </p>
            </div>
          </div>
        </div> */}
      </div>
      {/* <!-- /hero_map --> */}
      <Footer />
    </>
  );
};

export default Home;
